import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ONE_STOP_PATH } from 'domain/shared/oneStop';
import { ListProvider, StaticFilters } from 'framework/list';
import { useShowContext } from 'framework/show';
import { StaffingDataType } from 'domain/shared/staffing';
import AssignmentsBlockHeader from './AssignmentsBlockHeader';
import { useAssignmentsBlock } from './useAssignmentsBlock';
import { DashboardItemSectionWrapper } from 'framework/ui/dashboard';
import { mapTeamStructureWithAssignments } from 'domain/shared/assignment/mapTeamStructureWithAssignments';
import AssignmentsList from './List/AssignmentsList';

const AssignmentsWrapper = () => {
  const navigate = useNavigate();
  const { data, setData } = useShowContext<StaffingDataType>();
  const projectData = data.getData();
  const mappedTeamStructure = mapTeamStructureWithAssignments(projectData, projectData.team).team.expectedStructure;
  const { contextValue, assignmentsFilters } = useAssignmentsBlock(mappedTeamStructure);

  return (
    <ListProvider value={contextValue}>
      <StaticFilters>
        <DashboardItemSectionWrapper
          sx={{ '.MuiAccordionSummary-root': { pr: 0 } }}
          title={
            <AssignmentsBlockHeader
              assignmentsFilters={assignmentsFilters}
              onRequestVacancy={() => navigate(`${ONE_STOP_PATH}/REC04-NEW`)}
              variant="dashboard"
            />
          }
          defaultExpanded
        >
          <AssignmentsList projectData={projectData} setProjectData={setData} />
        </DashboardItemSectionWrapper>
      </StaticFilters>
    </ListProvider>
  );
};

export default AssignmentsWrapper;
